'use client';

import useSWR from 'swr';
import { goalsApi } from '@/lib/api';
import type { GoalsOverview } from '@/types';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

/**
 * The user's metas, for the Categorias goal-link picker (and any lightweight goal
 * list). `enabled: false` keeps the request off until the picker actually opens.
 */
export function useGoalsOverview(enabled = true) {
  const authedFetch = useAuthedFetcher();

  return useSWR<GoalsOverview>(
    enabled ? ['goals-overview'] : null,
    () => authedFetch((token) => goalsApi.getOverview(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
